import {MasterCategory, SubCategory} from "../index";
import { isMasterCategory } from './isMasterCategory';

export const isSubCategory = (category: MasterCategory|SubCategory): category is SubCategory => {
	return !isMasterCategory(category)
}